export const URLs = {
  getAgentDashboardOrgPrograms: `AgentDashboard/GetAgentDashboardOrgPrograms`,
  getAgentDashboardOrgProgramsTimeFrame: `AgentDashboard/GetAgentDashboardOrgProgramsTimeFrame`,
  getAgentDashboardDataCoachingConfig: `AgentDashboard/GetAgentDashboardDataCoachingConfig`,
  getAgentDashboardOrgProgramsBasedOnRecorddateAndType: `AgentDashboard/GetAgentDashboardOrgProgramsBasedOnRecorddateAndType`,
  getDimWorkWeeksAll: `WorkWeeks/GetDimWorkWeeksAll`,
  getAgentDetails: `AgentDashboard/GetExecAgentDetails`,
  getUserMetaData: `Login/GetUserMetaDataReact`,
  getAgentCoachHistory: `AgentDashboard/GetAgentCoachHistory`,
  getAgentCoachHistoryById: `AgentDashboard/GetAgentCoachHistoryById`,
  agentdbRecognizationDetails: `AgentDashboard/agentdbrecognizationdetails`,
  getAgentGameTable: `AgentDashboard/GetAgentGameTable`,
  getActivityDashboard: `React/getActivityDashboard`,
  getAgentCurrentCommitments: `AgentDashboard/GetAgentCurrentCommitments`,
  getAgentCurrentCommitmentsByCoachingId: `AgentDashboard/GetAgentCurrentCommitmentsByCoachingId`,
  getAgentBestPractices: `AgentDashboard/GetAgentBestPractices`,
  getExecAgentDashboardMetrics: `AgentDashboard/GetExecAgentDashboardMetrics`,
  getdashboardconfigurationValues: `AgentDashboard/getdashboardconfigurationValues`,
  latestcompletedrecord: `AgentDashboard/latestcompletedrecord`,
  getExecAGentBalanceScoreCardPopup: `AgentDashboard/GetExecAGentBalanceScoreCardPopup`,
  getCompanyOrgProgramConfigurations: `Game/GetCompayOrgConfigurationValues`,
  getMetricDetailsPopupListView: `M1_M2Dashboard/GetAllMetricDetails_MetricDetailsPopup_ListViewTimeFrame`,
  getAgentMetricDetailsPopup: `M1_M2Dashboard/GetPerformanceTrendCharts_AgentMetricDetailsPopupTimeFrame`,
  getCoachingsMetricDetailPopup: `M1_M2Dashboard/GetCoachings_MetricDetailPopup`,
  getMetricDetailsPopup: `M1_M2Dashboard/GetAllMetricDetails_MetricDetailsPopupTimeFrame`,
  getMetricDetailsPopupTrendChart: `M1_M2Dashboard/GetMetricDetailTrendChart_MetricDetailsPopupTimeFrame`,
  getAgentDashboardMetrics: `AgentDashboard/GetLeaderboardMetricsExecAgentDBNew`,
  getExecAgentdashboardCoachingDetails: `CoachingFollowupReact/GetExecAgentdashboardCoachingDetails`,
  getexecagentactivityhistoryview: `CoachingFollowup/Getexecagentactivityhistoryview`,
  taskManagementModule: `TaskManagement/taskManagementModule`,
  getqudarantthreecardsExecAgent: `AgentDashboard/GetqudarantthreecardsExecAgentDBNew`,
  getAgentCoachHistoryV3byactivityid: `CoachingFollowupReact/getAgentCoachHistoryV3byactivityid`,
  getmultimonthscorecarddimworkweeks: `AgentDashboard/Getmultimonthscorecarddimworkweeks`,
  getmultimonthScoreCardPopup: `AgentDashboard/GetmultimonthScoreCardPopup`,
  getmultimonthscorecardemployeedetails: `AgentDashboard/getmultimonthscorecardemployeedetails`,
  getGameByCompanyGuidOrgProgramEmpid: `Game/GetGameByCompanyGuidOrganizationProgramEmployeeid`,
  getMetricCalculationsMetricDetailPopup: `M1_M2Dashboard/GetMetricCalculations_MetricDetailPopup`,
  getActivityHistory: `CoachingFollowup/getActivityHistoryAPI`,
  getTaskSaveListForLastHistory: `TaskManagement/getTaskSaveListForLastHistory`,
  leaderBoardAPI: `CoachingFollowupReact/leaderBoardAPI`,
  taskHistory: `CoachingFollowupReact/TaskHistory`,
  getMultiMonthScoreCardPermission: `AgentDashboard/GetMultiMonthScoreCardPermission`,
  getAgentScheduling: `AgentDashboard/GetAgentScheduling`,
  getAgentInsentiveTables: `AgentDashboard/GetAgentInsentiveTables`,
  getIncentiveCardsExportAndPopUp: `AgentDashboard/GetIncentiveCards_ExportAndPopUp`,
  getCxPBEstimatedPayout: `CoxIncentives/GetCxPB_EstimatedPayout`,
  getS2SEstimatedPayout: `CoxIncentives/GetS2S_EstimatedPayout`,
  getCompayConfigurationValues: `Game/GetCompayConfigurationValues`,
  cxPBCalculatePotentialPayout: `dashboardNew/CxPB_CalculatePotentialPayout`,
  getMTDMyLevelupTileDetails_YTD: `AgentDashboard/GetMTDMyLevelupTileDetails_YTD`,
  getAIMLMessages: `AgentDashboard/Getaimlmessages`,
  getAgentAIMLConfigurations: `AgentDashboard/GetAgentAIMLMessagePopupConfigurations`,
  getAdditionalLinksFlagMetricDetail: `M1_M2Dashboard/GetAdditionalLinksAndCoachButtonFlag_MetricDetailPopup`,
  getIntradayAgentDashboardTicker: `AgentDashboard/GetIntradayAgentDashboardTicker`,
  getCxPBRankingDetails: `CoxIncentives/Get_CxPBRankingDetails`,
  getCxPBRankingDetails: `CoxIncentives/Get_CxPBRankingDetails`,
  getHelpTipsByModule: `HelpTips/GetHelpTipsByModule`,
  getEstimatedIncentivePayOutDetails: `AgentDashboard/GetEstimatedIncentivePayOutDetails`,
  getAloricaIncentiveCardsDetails: `AgentDashboard/GetAloricaIncentiveCardsDetails`,
  getIncentiveTilePopUpData: `IncentiveTilesSummary/getIncentiveTilePopUpData`,
  activityHistoryViewReact: `React/activityhistoryview_react`,
  getMyEvaluationHistoryData: `Evaluation/GetMyEvaluationHistoryData`,
  getMyEvaluationESIIHistoryData: `EvaluationESII/GetMyEvaluationESIIHistoryData`,
  myEvaluationESIIHistoryDetailsReact: `React/MyEvaluationESIIHistoryDetailsReact`,
  myEvaluationHistoryDetailsReact: `React/MyEvaluationHistoryDetailsReact`,
  myEvaluationHistoryDetailsReact: `React/MyEvaluationHistoryDetailsReact`,
  rightSideTaskSaveManagementDetailsReact: `React/RightSideTaskSaveManagementDetailsReact`,
  getAgentIncentiveRings: `AgentDashboardCosmosDB/GetAgentIncentiveRings`,
  getAgentIncentiveRingsDetails: `AgentDashboardCosmosDB/GetAgentIncentiveRingsDetails`,
};
// getMetricDetailsPopup: `M1_M2Dashboard/GetAllMetricDetails_MetricDetailsPopup`,
// getAgentDashboardMetrics: `AgentDashboard/GetAgentDashboardMetrics`,
